// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ng53","label":"styles_label__egDbB"};